export const appTitle = "PrEP-it";

/* Tools */

export const noToolSelected = 0;
export const PrEPitStdTool = 1;
export const PrEPitEasyStartTool = 2;
export const aggregateTool = 3;

/* Forms */

export const welcomeForm = "PIWelcomeForm";
// export const gettingStartedForm      = "PIGettingStartedForm";
export const configForm = "PIConfigForm";
export const targetsForm = "PITargetsForm";
export const disagTargetsForm = "PIDisagTargetsForm";
export const detailedCostsForm = "PIDetailedCostsForm";
export const costsLiteForm = "PICostsLiteForm";
export const impactForm = "PIImpactForm";
export const AGYW_Form = "PIAGYWForm";
export const capacityForm = "PICapacityForm";
export const commoditiesForecastForm = "PICommoditiesForecastingForm";
export const customPriorPopsFormLv2 = "PICustomPriorPopsFormLv2";
export const resultsDashboardForm = "PIResultsDashboardForm";
export const gettingStartedForm = "PIGettingStartedForm";
export const aggregateForm = "PIAggregateForm";
export const resourcesForm = "PIResourcesForm";
export const testForm = "PITestForm";

export const noPageID = "";

/* Form order, used to help determine which form to display next/previously
   when navigating forms. */

export const welcomeFormOrder = 1;
export const firstForm = welcomeFormOrder;
export const gettingStartedFormOrder = 2;
export const aggregateFormOrder = 3;
export const configFormOrder = 4;
export const detailedCostsFormOrder = 5;
export const costsLiteFormOrder = 6;
export const AGYW_FormOrder = 7;
export const impactFormOrder = 8;
export const targetsFormOrder = 9;
export const resultsDashboardFormOrder = 10;
export const disagTargetsFormOrder = 11;
export const commoditiesForecastFormOrder = 12;
export const finalForm = commoditiesForecastFormOrder;

/* Drawers */

export const resultsDrawer = "PIResultsDrawer";
export const continuationDrawer = "PIContinuationSlideDrawer";
export const visitSchedDrawer = "PIVisitSchedSlideDrawer";
export const progDataDrawer = "PIProgDataSlideDrawer";
export const customPriorPopsDrawerLv2 = "PICustomPriorPopsSlideDrawerLv2";
export const itemsSlideDrawer = "PIItemsSlideDrawer";

export const noCountrySelected = -1;

export const defaultAppBarHeight = 64;

/* Time periods */

export const firstPossibleProgramStartYear = 2008;
export const finalPossibleProgramStartYear = 2026;

export const firstPossibleProgramEndYear = 2008;
export const finalPossibleProgramEndYear = 2026;

export const firstPossibleTargetStartYear = 2020; //2018;
export const finalPossibleTargetStartYear = 2030; //new Date().getFullYear();

export const firstPossibleTargetEndYear = 2020; //2018;
export const finalPossibleTargetEndYear = 2030;

export const progDataPeriod = 1;
export const targSetPeriod = 2;
export const dateRangeDisplayPeriod = 3;
export const indProgDataPeriod = 4; // For currently hidden program data results
// replaced with DRI, now DRD, ...export const commForePeriod       = 5;

export const start = 1;
export const end = 2;

export const back = 1;
export const next = 2;

/* Directions to shift groups, etc. */

export const moveUp = 1;
export const moveDown = 2;

/* For shifting data structures when items are added or deleted (ex: priority pops). */
export const addItem = 1;
export const deleteItem = 2;
export const moveItem = 3;

/* Server call parameters */

export const countryCode = "countryCode";

export const drawerLv1 = 1;
export const drawerLv2 = 2;
export const drawerLv3 = 3;
export const numDrawerLvs = drawerLv3;

/* Default priority populations (PPs) */

export const SDC_PPCurrID = 1; // Sero discordent couples
export const AGYW_PPCurrID = 2; // Adolescent girls/young women 15-24
export const MSM_PPCurrID = 3; // Men who have sex with men
export const FSW_PPCurrID = 4; // Female sex workers
export const PWIDU_PPCurrID = 5; // People who inject drugs
export const numDefPriorPops = PWIDU_PPCurrID;
/* There is one custom priority population to start. */
export const custom_PPCurrID = 6;

export const KEYPOP_PPCurrID = [MSM_PPCurrID, FSW_PPCurrID, PWIDU_PPCurrID]; // Key populations (aggregate)

/* Default continuation curves (CCs) */

export const SDCsCCCurrID = 1;
export const AGYW15t24CCCurrID = 2;
export const MSMCCCurrID = 3;
export const FSWCCCurrID = 4;
export const PBWCCCurrID = 5;
export const numDefContCurves = PBWCCCurrID;

export const maxContCurves = 6;

/* Continuation curves periods */

export const after1MoCurrID = 1;
export const after3MoCurrID = 2;
export const after6MoCurrID = 3;
export const after12MoCurrID = 4;
export const after24MoCurrID = 5;
export const numContCurvePeriods = after24MoCurrID;

/* Default data elements (Initiation) */

export const numInitPrEPCurrID = 1;
export const numReinitPrEPCurrID = 2;

export const numDefDataElements = 2;

/* Scale-up trends */

export const scaleUpTrendACurrID = 1;
export const scaleUpTrendBCurrID = 2;
export const scaleUpTrendCCurrID = 3;
export const numDefScaleUpTrends = scaleUpTrendCCurrID;

export const maxScaleUpTrends = 3;

/* Scale-up types */

export const sShapedScaleUpCurrID = 1;
export const linearScaleUpCurrID = 2;
export const constantScaleUpCurrID = 3;
export const numScaleUpTypes = constantScaleUpCurrID;

/* Target-setting (TS) options */

export const coverageTargSetOptCurrID = 1;
export const constraintsTargSetOptCurrID = 2;
export const manualTargSetOptCurrID = 3;
export const numTargSetOptions = manualTargSetOptCurrID;

/* Impact scenario (IS) options */

export const constCovImpOptCurrID = 1;
export const ninetyX3ImpOptCurrID = 2;
export const numImpOptions = ninetyX3ImpOptCurrID;

/* Item type */

export const priorPopItems = 1;
export const unused = 2; // was used by persTypeItems
export const unused2 = 3; // was used by servDelivStratItems
export const unused4 = 4; // was used by labTestItems
export const unused5 = 5; // was used by contVisitItems
export const contVisitSchedItems = 6;
export const contCurveItems = 7;
export const scaleUpTrendItems = 8;
export const unused9 = 9; // was used by minutePatternItems
export const unused10 = 10; // was used by servDelivUnitItems
export const methodItems = 11;
export const unused12 = 12; // was used by staffTypeItems

/* Education codes */

export const eduCodeICurrID = 1;
export const eduCodeIICurrID = 2;
export const eduCodeIIICurrID = 3;
export const eduCodeIVCurrID = 4;
export const eduCodeVCurrID = 5;
export const numEduCodes = eduCodeVCurrID;

/* Visit types */

export const initVisitCurrID = 1;
export const contVisitCurrID = 2;
export const numVisitTypes = contVisitCurrID;

/* Staff types (Capacity) */

export const staffACurrID = 1;
export const staffBCurrID = 2;
export const numStaffTypes = staffBCurrID;

/* Lab tests */

export const HIVRapidTestCurrID = 1;
export const ELISATestCurrID = 2;
export const HBsAgTestCurrID = 3;
export const ALTTestCurrID = 4;
export const pregTestUrineCurrID = 5;
export const rapidSyphTestCurrID = 6;
export const RPRTitreTestCurrID = 7;
export const creatinineTestCurrID = 8;
export const PrEPDrugLevelTestCurrID = 9;
export const numDefLabTests = PrEPDrugLevelTestCurrID;

/* Continuation visits (CV) */

export const initVisitCVCurrID = 1;
export const numDefContVisits = initVisitCurrID;

/* Initiation visits */

export const contVisitSched1CurrID = 1;
export const contVisitSched2CurrID = 2;
export const contVisitSched3CurrID = 3;
export const contVisitSched4CurrID = 4;
export const numDefContVisitSchedules = contVisitSched4CurrID;

/* Continuation visit options */

export const yesCVOCurrID = 1;
export const noCVOCurrID = 2;
export const dashCVOCurrID = 3;
export const numContVisitOptions = dashCVOCurrID;

/* Minute patterns */

export const SDCsMPCurrID = 1;
export const keyPopsMPCurrID = 2;
export const AGYWMPCurrID = 3;
export const genPopMPCurrID = 4;
export const dropInCenterMPCurrID = 5;
export const pubHlthCenterMPCurrID = 6;
export const pubHospMPCurrID = 7;
export const privClinicMPCurrID = 8;
export const numMinPatterns = privClinicMPCurrID;

/* Detailed costs */

export const overheadCostCurrID = 1;
export const capCostCurrID = 2;
export const numDetCostDefRatioTypes = capCostCurrID;

/* Cost categories, Costs per visit (CPV), Costs Lite */

export const personnelCostCatCPVCurrID = 1;
export const labCostCatCPVCurrID = 2;
export const otherRecurCostCatCPVCurrID = 3;
export const capCostCatCPVCurrID = 4;
export const totalCostCatCPVCurrID = 5;
export const numCostCatCPV = totalCostCatCPVCurrID;

/* Minute patterns, Costs per visit (CPV), Costs Lite */

export const SDCMinPatCPVCurrID = 1;
export const keyPopsMinPatCPVCurrID = 2;
export const AGYWMinPatCPVCurrID = 3;
export const numMinPatCPV = AGYWMinPatCPVCurrID;

/* AGYW Area types */

export const noAreaSelected = -1;
export const nationalArea = 1;
export const regionalArea = 2;
export const districtArea = 3;

/* Naomi area file */

export const areaISO3MstID = "iso3";
export const areaNameMstID = "area_name";
export const areaIDMstID = "area_id";
export const areaLevelMstID = "area_level";

export const areaISO3Idx = 0;
export const areaNameIdx = 1;
export const areaIDIdx = 2;
export const areaLevelIdx = 3;

export const nationalMstID = 0;
export const regionalMstID = 1;
export const districtMstID = 2;

/* Methods */

export const pillMethodCurrID = 1;
export const ringMethodCurrID = 2;
export const CAB_LAMethodCurrID = 3;
export const numMethods = CAB_LAMethodCurrID;

/* AGYW - Threshold criterion */

export const totalCostSavingsAGYWCurrID = 1;
export const PrEPCostInfAvtdAGYWCurrID = 2;

/* AGYW - Source for cost per person-year on PrEP */

export const AGYW_PerPYPrEPFromCostingSrcCurrID = 1;
export const AGYW_EnterPerPYPrEPSrcCurrID = 2;

/* AGYW - Cost per person year on ART entry type */

export const AGYW_SingleCostPerPerPYARTCurrID = 1;
export const AGYW_CostPerPerPYByAreaARTCurrID = 2;

/* Disaggregate targets - Priority populations included by age/sex age groups */

export const age15t19PPIASCurrID = 1;
export const age20t24PPIASCurrID = 2;
export const age25t29PPIASCurrID = 3;
export const age30t34PPIASCurrID = 4;
export const age35t39PPIASCurrID = 5;
export const age40t44PPIASCurrID = 6;
export const age45t49PPIASCurrID = 7;
export const age50t54PPIASCurrID = 8;
export const age55t59PPIASCurrID = 9;
export const age60t64PPIASCurrID = 10;
//export const age50PlusPPIASCurrID = 8;
export const age65PlusPPIASCurrID = 11;
export const numAgeGroupsPPIAS = age65PlusPPIASCurrID;

/* URLS */

export const naomiViewerURL = "https://naomi-spectrum.unaids.org/";
export const HIVCostingToolURL = "https://beta.avstaging.org/HIVCostingTool";

/* Resources */

export const areaTemplateCSV = "NaomiAreaTemplate.csv";
export const provDistTemplateCSV = "ProvincesAndDistricts.csv";
export const subnatTemplateXLSX = "Subnational Template.xlsx"; // replaces provDistTemplateCSV
export const AGYWDataTemplateXLSX = "AGYW Data Template.xlsx"; // replaces areaTemplateCSV
export const availableContinuationDataXLSX = "Available continuation data.xlsx";
export const coverageRecsXLSX = "PrEP_Coverage.xlsx";

/* Validation items (VI) */

export const potUsersVI = "potUsersVI";
export const AGYWParamsVI = "AGYWParamsVI";

export const AngolaCountryCode = 24;

/* If you're temporarily unable to assign a master ID to anything, use this
   temporarily and then assign the proper master ID at the right time. */
export const noMstID = "NONE";

export const itemDoesNotExist = -1;

export const AGYWRegionsPerPage = 20;

export const methodStr = "METHOD";
export const unitCommStr = "UNITCOMM";
export const modeStr = "MODE";
export const numItemsStr = "NUMITEMS";

export const noNextOrPrevForm = -1;

/* Limits */
export const MaxAboveSiteLumpSumCostCategories = 6;

/* Default cost references */
export const defaultCostReferences = [
  "Wanga V, Peebles K, Obiero A, Mogaka F, et al. Cost of pre-exposure prophylaxis delivery in family planning clinics to prevent HIV acquisition among adolescent girls and young women in Kisumu, Kenya. PLoS One. 2021 Apr 15;16(4):e0249625. doi: 10.1371/journal.pone.0249625.",
  "Ekirapa E, Jordan M, Nong T, Marton TE et al. Costs and resource distribution of direct services for HIV in Uganda. BMJ Open. 2024 Oct 9;14(10):e082062. doi: 10.1136/bmjopen-2023-082062.",
  "Stegman P, Forsythe S, Kioko U, Kiruki M, et al. Estimating the cost of and willingness to pay for providing the dapivirine ring for HIV prevention in Kenya. BMC Public Health. 2025 Mar 22;25(1):1095. doi: 10.1186/s12889-025-22291-5.",
  "Forsythe S, Kioko U, Mahiane G, Glaubius R, et al. Estimating the costs and perceived benefits of oral pre-exposure prophylaxis (PrEP) delivery in ten counties of Kenya: a costing and a contingent valuation study. Front Reprod Health. 2024 Feb 23;6:1278764. doi: 10.3389/frph.2024.1278764.",
  "Chen Y, Montaño MA, Naik P, Thuo N, et al. Incremental cost of pre- and post-exposure prophylaxis service provision via an online pharmacy in Kenya. J Acquir Immune Defic Syndr. 2025 Apr 8. doi: 10.1097/QAI.0000000000003680.",
  "Mudimu E, Sardinia J, Momin S, Medina-Marino A, et al. Incremental costs of integrated PrEP provision and effective use counselling in community-based platforms for adolescent girls and young women in South Africa: an observational study. J Int AIDS Soc. 2022 Feb;25(2):e25875. doi: 10.1002/jia2.25875.",
  "Peebles K, Mugwanya KK, Irungu E, Odoyo J, et al., Partners Scale-Up Project Team. Low costs and opportunities for efficiency: a cost analysis of the first year of programmatic PrEP delivery in Kenya's public sector. BMC Health Serv Res. 2021 Aug 16;21(1):823. doi: 10.1186/s12913-021-06832-3.",
  "McBain RK, Jordan M, Mann C, Ruhago GM, et al. National Evaluation of HIV Service Resource Allocation in Tanzania. AIDS Behav. 2023 Oct;27(10):3498-3507. doi: 10.1007/s10461-023-04065-5. Epub 2023 May 5.",
  "Pintye J, Kinuthia J, Roberts DA, Wagner AD, et al. Brief Report: Integration of PrEP Services Into Routine Antenatal and Postnatal Care: Experiences From an Implementation Program in Western Kenya. J Acquir Immune Defic Syndr. 2018 Dec 15;79(5):590-595. doi: 10.1097/QAI.0000000000001850.",
];
